export default __webpack_public_path__ + "static/media/1810.aabe8aa4.png";